import { useIntl } from "react-intl";

export function useResolveChannelNumber(channelNumber: number | string){
  const intl = useIntl();

  if (!channelNumber) return '';

  return intl.formatMessage({ id: 'Epg.ProgramCard.channelNumber', defaultMessage: `channel number ${channelNumber}` }, { value: channelNumber });
}
